import { Otp } from '@repo/shared/components'
import { useTranslate } from '@repo/shared/hooks'
import { useAgentPhoneOtp, useAgentSetUserPhone } from '@repo/services'
import { Button, Col, onCloseModal, toast } from '@repo/ui/components'
import { useRef, useState } from 'react'
import { IChangeMobileKycOtpProps } from './change-mobile-kyc.types'
import { normalizeMobile } from '@repo/ui/lib'
import { useErrorHandler } from '@repo/shared/hooks'
export const ChangeMobileKycOtp = (props: IChangeMobileKycOtpProps) => {
  const { mobile, otp, handleBack } = props
  const { t } = useTranslate()

  const [otpCode, setOtpCode] = useState<string>('')
  const phoneOtpMutation = useAgentPhoneOtp()
  const setUserPhoneMutation = useAgentSetUserPhone({ invalidate: true })
  const { errorHandler } = useErrorHandler()
  const submitRef = useRef(null)

  const handleResend = () => {
    phoneOtpMutation.mutate(
      { phone: normalizeMobile(mobile) },
      { onError: errorHandler },
    )
  }

  const handleOtpComplete = (code: string) => {
    setOtpCode(code)
  }

  const handleSubmit = async (code: string = otpCode) => {
    if (!code || code.length !== 5) return
    setUserPhoneMutation.mutate(
      { phone: normalizeMobile(mobile), otp: Number(otp), code },
      {
        onError: errorHandler,
        onSuccess: () => {
          toast.success({
            title: t('changeMobileKyc_success'),
          })
          setUserPhoneMutation.reset()
          onCloseModal()
        },
      },
    )
  }

  return (
    <Col className='gap-3xl mt-md'>
      <Otp
        mobileOrEmail={mobile}
        onResend={handleResend}
        onComplete={handleOtpComplete}
        onEdit={handleBack}
        focusRef={submitRef}
      />
      <Button
        ref={submitRef}
        size='lg'
        className='w-full'
        onClick={() => handleSubmit()}
        disabled={otpCode.length !== 5}
        loading={setUserPhoneMutation.isPending}
      >
        {t('common_verify')}
      </Button>
    </Col>
  )
}
